export default __webpack_public_path__ + "static/residency-header-f3525726fc73cb2562d41edf324c0ddb.webp";